export const innerCalendarColor = {
  colorName: 'INNER_CALENDAR_COLOR', 
  hexCode: '#3273E1',
};
